module.exports = __webpack_public_path__ + "static/img/Tom_Mitchell_desktop.4f765e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tom_Mitchell_desktop.jpg
// module id = mpuZ
// module chunks = 0